import { ListItem } from '../../../model/controls/ListItem';
import { ComparisonType } from '../../../model/search/advanced/ComparisonType';
import { MultiTextField } from '../../../model/search/advanced/MultiTextField';
import { Operator, SearchExpression } from '../../../model/search/advanced/SearchExpression';
import { SortDirection } from '../../../model/SortDirection';
import { DisplayMode } from '../../../model/user/Preferences';
import { Factory } from '../../../services/Factory';

export interface IDataGridScope extends angular.IScope {
  gridName: string;
  options: agGrid.GridOptions;
  dataSource: agGrid.IDatasource & agGrid.IServerSideDatasource;
  columnDefinitions: agGrid.ColDef[];
  sortModel: any;
  filterModel: any;
  resetWatch: Function;
  element: angular.IAugmentedJQuery;
  mode: any;
  DisplayMode;
  showCollection: boolean;
  noIndent: boolean
  pageSize: number;
  visibleRowCount: number;
  enableColumnPreferences?: boolean;
  totalRowCount: number;
  currentPage: number;
  getColumnHeaderName: Function;
  sort: Function;
  removeSort: Function;
  SortDirection: any;
  filteredColumns: Array<{ colId: string, value: string }>;
  preventDefault: Function;
  changeFilter: Function;
  removeFilter: Function;
  listViewCellRenderer: agGrid.ICellRendererFunc;
  enablePagination: boolean;
  infiniteScrollMode: boolean;
  alternatingRows: boolean;
  suppressRowClickSelection: boolean;
  autoSizeColumns: boolean;
  softRefresh: boolean;
  pinnedBottomRowData: any;
  pinnedTopRowData: any;
  rowHeight: number;
  autoRowHeight: boolean;
  getRowHeight: (params?) => number;
  selectAll: boolean;
  fitWithinContainerWithId: string;
  focusRowIndex: number;
  highlightFocusedRow: boolean;
  scrollToBottom: boolean;
  _: any;
  rowGroupingMode: boolean;
  rowSelection: "single" | "multiple" | "CheckboxOff" | undefined;
  groupRowCellRenderer: agGrid.ICellRendererFunc
  suppressHorizontalScroll: boolean;
}

export class GridViewConfigCellRenderer implements agGrid.ICellRendererComp {
  private gui: HTMLElement;

  refresh(params: any): boolean {
    params.$scope.$applyAsync();

    return true;
  }

  getGui(): HTMLElement {
    return this.gui;
  }

  init?(params: agGrid.ICellRendererParams): void | agGrid.Promise<void> {
    let content = `
          <div class="checkbox checkbox-primary">
            <input id="rowNode.rowIndex" type="checkbox" ng-checked="rowNode.selected" ng-click="rowNode.setSelected(!rowNode.selected)">
            <label for="rowNode.rowIndex" style="pointer-events:none;">
            </label>
          </div>
          `;
    if (params.data) {
      if (params.data.hadProcessingException) {
        content += `<i class="fas fa-exclamation-triangle fa-lg text-warning"></i>`;
      }

      if (params.data.hasVirus) {
        content += `<i class="fas fa-bug fa-lg text-danger"></i>`;
      }
      content += `<span class="pull-right badge" style="margin-top: 9px">${+params.node.id + 1}</span>`;
    } else {
      content += `<i class="fas fa-sync-alt fa-spin fa-fw"></i>`;
    }

    this.gui = $(`<div>${content}</div>`).get(0);
  }
}

export class DataGrid implements angular.IDirective {
  public restrict: string = 'E';
  public compile: angular.IDirectiveCompileFn;
  public template: string;
  public require: any[] = ["ngModel"];
  public scope = {
    gridName: "@",
    dataSource: "=ngModel",
    columnDefinitions: "=",
    sortModel: "=",
    filterModel: "=",
    mode: "=",
    showCollection: "=",
    visibleRowCount: "=",
    pageSize: "=",
    enableColumnPreferences: "=",
    listViewCellRenderer: "=",
    enablePagination: "=",
    infiniteScrollMode: "=",
    alternatingRows: "=",
    suppressRowClickSelection: "=",
    autoSizeColumns: "=",
    softRefresh: "=",
    pinnedTopRowData: "=",
    pinnedBottomRowData: "=",
    noIndent: "=",
    rowHeight: "=",
    autoRowHeight: "=",
    fitWithinContainerWithId: "@",
    focusRowIndex: "=",
    highlightFocusedRow: "=",
    getRowHeight: "&",
    selectAll: "=",
    scrollToBottom: "=",
    rowGroupingMode: "=",
    groupRowCellRenderer: "=",
    rowSelection: "@",
    suppressHorizontalScroll: "="
  };

  constructor($compile: angular.ICompileService) {
    this.template =
      `<div style="height:100%">
          <div ng-show="mode === DisplayMode.ListView && ((sortModel && sortModel.length > 0) || _.keys(filterModel).length > 0)">
              <div class="btn-group" role="group">
                  <div class="btn-group" uib-dropdown ng-repeat="sortedColumn in sortModel">
                    <button id="{{sortedColumn.colId}}" type="button" class="btn btn-default" uib-dropdown-toggle>
                      {{getColumnHeaderName(sortedColumn.colId)}}<span style="margin-left: 5px" ng-class="{'ag-icon': true, 'ag-icon-asc': sortedColumn.sort == 'asc', 'ag-icon-desc': sortedColumn.sort == 'desc'}"></span>
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="{{sortedColumn.colId}}">
                      <li><a ng-click="sort(sortedColumn.colId, SortDirection.ASC)">Ascending</a></li>
                      <li><a ng-click="sort(sortedColumn.colId, SortDirection.DESC)">Descending</a></li>
                      <li><a ng-click="removeSort(sortedColumn.colId)">Remove</a></li>
                    </ul>
                  </div>
              </div>
              <div class="btn-group" role="group">
                  <div class="btn-group" uib-dropdown ng-repeat="filteredColumn in filteredColumns">
                    <button id="{{filteredColumn.colId}}" type="button" class="btn btn-default" uib-dropdown-toggle>
                      {{getColumnHeaderName(filteredColumn.colId)}}<span style="margin-left: 5px" class="ag-icon ag-icon-filter"></span>
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="{{filteredColumn.colId}}">
                      <li style="padding: 5px">
                          <input type="text" class="form-control input-sm" ng-model="filteredColumn.value.filter" ng-change="changeFilter(filteredColumn.colId, filteredColumn.value)" ng-click="preventDefault($event)">
                      </li>
                      <li><a ng-click="removeFilter(filteredColumn.colId)">Remove</a></li>
                    </ul>
                  </div>
              </div>
          </div>
          <ul uib-pagination ng-show="(mode === DisplayMode.ListView && enablePagination === undefined && !infiniteScrollMode) || enablePagination" rotate="false" total-items="totalRowCount" ng-model="currentPage" items-per-page="visibleRowCount" max-size="10" class="pagination-sm" boundary-links="true"></ul>
          <div ag-grid="options" class="ag-theme-bootstrap" style="height: 100%;"></div>
          <ul uib-pagination ng-show="(mode === DisplayMode.ListView && enablePagination === undefined && !infiniteScrollMode) || enablePagination" rotate="false" total-items="totalRowCount" ng-model="currentPage" items-per-page="visibleRowCount" max-size="10" class="pagination-sm" boundary-links="true"></ul>
       </div>`;
    this.compile = () => {
      return {
        pre: (scope: IDataGridScope, element: JQuery, attributes: angular.IAttributes) => {
          scope.rowCountHeaderComponent = class {
            private eGui: HTMLElement;
            private $scope: angular.IScope;

            public init?(params: any) {
              this.eGui = $(`
                            <div class="settings dropdown" uib-dropdown auto-close="outsideClick">
                                <a href="#" uib-dropdown-toggle track="grid column settings">
                                    <i class="fas fa-sliders-h fa-lg"></i>
                                </a>
                                <ul uib-dropdown-menu style="width: 230px">
                                    <li ng-repeat="columnDefinition in columnDefinitions">
                                        <a ng-click="toggleVisible(columnDefinition)">
                                           {{columnDefinition.headerName}}<i class="fas fa-check pull-right" ng-show="!columnDefinition.hide"></i>
                                        </a>
                                    </li>
                                    <li class="divider"></li>
                                    <li><a ng-click="resetSettings()">Reset</a></li>
                                </ul>
                            </div>`)[0];

              this.$scope = scope.$new();
              $compile(this.eGui)(this.$scope);


              this.$scope.columnDefinitions = _.filter(scope.columnDefinitions, c => !!c.field);

              this.$scope.toggleVisible = columnDefinition => {
                columnDefinition.hide = !columnDefinition.hide;
                this.$scope.$parent.options.columnApi.setColumnVisible(columnDefinition.colId ? columnDefinition.colId : columnDefinition.field, !columnDefinition.hide);
              };

              this.$scope.resetSettings = () => {
                this.$scope.$parent.sortModel = null;
                this.$scope.$parent.filterModel = null;
                this.$scope.$emit("DataGridColumnsResetEvent");
              };

              this.$scope.params = params;
              this.$scope.$applyAsync();
            }

            public getGui(): HTMLElement {
              return this.eGui;
            }

            public destroy?() {
              this.$scope.$destroy();
            }
          };

          if (!attributes.getRowHeight) {
            scope.getRowHeight = () => scope.rowHeight || (scope.mode === DisplayMode.GridView ? 48 : 124);
          }

          scope.DisplayMode = DisplayMode;
          scope.SortDirection = SortDirection;
          scope.currentPage = 1;
          scope.options = {
            defaultColDef: {
              menuTabs: ['generalMenuTab', 'filterMenuTab'],
              filter: "agTextColumnFilter",
              sortable: true,
              resizable: true,
            },
            groupUseEntireRow: scope.rowGroupingMode,
            groupRowRenderer: scope.groupRowCellRenderer,
            groupSuppressAutoColumn: scope.rowGroupingMode,
            animateRows: !scope.autoRowHeight,
            groupSelectsChildren: scope.rowGroupingMode,
            suppressRowClickSelection: scope.suppressRowClickSelection ?? false,
            suppressPaginationPanel: true,
            suppressContextMenu: true,
            suppressHorizontalScroll: scope.suppressHorizontalScroll ?? scope.mode === DisplayMode.ListView,
            angularCompileRows: true,
            suppressCellSelection: true,
            paginationPageSize: scope.mode === DisplayMode.GridView && !scope.enablePagination ? scope.pageSize : scope.visibleRowCount,
            cacheBlockSize: scope.pageSize,
            headerHeight: scope.mode === DisplayMode.GridView && !scope.rowGroupingMode ? 30 : 0,
            rowModelType: scope.rowGroupingMode || scope.autoRowHeight ? "serverSide" : "infinite",
            rowHeight: scope.getRowHeight(),
            rowSelection: scope.rowSelection && scope.rowSelection !== "CheckboxOff" ? scope.rowSelection : scope.rowGroupingMode ? "single" : "multiple",
            rowMultiSelectWithClick: true,
            maxConcurrentDatasourceRequests: 2,
            pagination: (scope.mode === DisplayMode.ListView && !scope.infiniteScrollMode) || scope.enablePagination,
            overlayLoadingTemplate: '<i class="fas fa-circle-notch fa-spin fa-5x fa-fw"></i>',
            icons: {
              columnMovePin: '<i class="fas fa-thumb-tack"/>',
              columnMoveAdd: '<i class="fas fa-eye"/>',
              columnMoveHide: '<i class="fas fa fa-eye-slash"/>',
              columnMoveMove: '<i class="fas fa-arrows"/>',
              columnMoveLeft: '<i class="fas fa-arrow-left"/>',
              columnMoveRight: '<i class="fas fa-arrow-right"/>',
              columnMoveGroup: '<i class="fas fa-group"/>'
            },
            getRowHeight: params => {
              return scope.getRowHeight({
                params,
                columnWidth: scope.options.columnApi.getAllColumns()[0].getActualWidth()
              });
            },
            onGridSizeChanged: e => {
              if (e.clientWidth <= 0) return;
              const count = e.columnApi.getAllDisplayedColumns().length;
              if (count <= 5 && count > 0 || scope.autoSizeColumns) {
                scope.options.api.sizeColumnsToFit();
              }
            },
            onDisplayedColumnsChanged: e => {
              const count = e.columnApi.getAllDisplayedColumns().length;
              if (count <= 5 && count > 0 || scope.autoSizeColumns) {
                if (scope.element[0].clientWidth > 0) {
                  scope.options.api.sizeColumnsToFit();
                }
              }
            },
            onPaginationChanged: () => {
              if (!scope.options.api) { return; }
              const page = scope.options.api.paginationGetCurrentPage() + 1;

              // Keep the AngularJS uib-pagination control in sync when ag-Grid
              // changes pages internally (e.g. via ensureIndexVisible from row
              // navigation). The guard prevents a feedback loop with the
              // $watch('currentPage') → paginationGoToPage path.
              if (scope.currentPage !== page) {
                scope.$applyAsync(() => { scope.currentPage = page; });
              }

              if (scope.mode === DisplayMode.ListView || page === 0 || scope.enablePagination) {
                scope.totalRowCount = scope.options.api.paginationGetRowCount();

                let count = scope.visibleRowCount * page > scope.totalRowCount ? scope.totalRowCount - scope.visibleRowCount * (page - 1) : scope.visibleRowCount;

                if (scope.pinnedTopRowData) {
                  count += 1;
                }

                if (scope.pinnedBottomRowData) {
                  count += 1;
                }

                if (!scope.fitWithinContainerWithId) {
                  scope.element.height(scope.getRowHeight() * count + (scope.mode === DisplayMode.GridView && scope.enablePagination ? 30 : 0) + 5 + "px");
                }
              }

              if (scope.selectAll) {
                scope.options.api.forEachNode(n => n.setSelected(scope.selectAll));
              }
            },
            onColumnVisible: e => {
              _.find(scope.columnDefinitions, c => e.column.getColId() === (c.colId ?? c.field)).hide = !e.visible;

              if (scope.mode === DisplayMode.GridView) {
                scope.$emit("DataGridColumnsChangedEvent", _.filter(scope.columnDefinitions, c => !!c.field));
              }

              if (_.filter(scope.options.columnApi.getAllColumns(), c => c.isVisible()).length <= 5) {
                scope.options.api.sizeColumnsToFit();
              }
            },
            onColumnMoved: e => {
              let index = _.findIndex(scope.columnDefinitions, c => e.column.getColId() === (c.colId ?? c.field));
              if (index > -1 && index !== e.toIndex) {
                scope.columnDefinitions.splice(e.toIndex, 0, scope.columnDefinitions.splice(index, 1)[0]);

                scope.$emit("DataGridColumnsChangedEvent", _.filter(scope.columnDefinitions, c => !!c.field));
              }
            },
            onColumnPinned: e => {
              _.find(scope.columnDefinitions, c => e.column.getColId() === (c.colId ?? c.field)).pinned = e.pinned;

              scope.$emit("DataGridColumnsChangedEvent", _.filter(scope.columnDefinitions, c => !!c.field));
            },
            onColumnResized: e => {
              _.forEach(scope.columnDefinitions, c => {
                if (e.column.getColId() === (c.colId ?? c.field)) {
                  c.width = e.column.getActualWidth();
                }
              });

              if (scope.mode === DisplayMode.GridView) {
                scope.$emit("DataGridColumnsChangedEvent", _.filter(scope.columnDefinitions, c => !!c.field));
              }
            },
            onRowClicked: e => {
              if (scope.rowGroupingMode && e.data.id) {
                scope.$emit("DataGridGroupedRowSelectedEvent", {
                  data: e.data,
                  index: e.rowIndex,
                  grid: scope.options
                });
              }

              if (!scope.rowGroupingMode && !$(e.event.target).closest('.checkbox').length) {

                scope.$emit("DataGridRowSelectedEvent", {
                  data: e.data,
                  index: e.rowIndex,
                  grid: scope.options
                });
              } else {
                if (scope.selectAll) {
                  e.node.setSelected(true);
                } else {
                  e.node.setSelected(!e.node.isSelected());
                  e.api.refreshCells({rowNodes: [e.node], force: true});

                  scope.$emit("DataGridRowCheckedEvent", {
                    data: e.data,
                    index: e.rowIndex,
                    grid: scope.options
                  });
                }
              }
            },
            onSortChanged: () => {
              scope.$emit("DataGridSortChangedEvent", scope.options.api.getSortModel());
            },
            onFilterChanged: () => {
              scope.$emit("DataGridFilterChangedEvent", scope.options.api.getFilterModel());

              if (!scope.filteredColumns) {
                const keys = _.keys(scope.options.api.getFilterModel());
                const values = _.values(scope.options.api.getFilterModel());
                const columns = [];
                keys.forEach((k, i) => columns.push({colId: k, value: values[i]}));
                scope.filteredColumns = columns;
              }
            },
            onGridReady: () => {
              scope.$emit("DataGridReadyEvent", {name: scope.gridName, api: scope.options.api, columnApi: scope.options.columnApi});

              if (scope.resetWatch) {
                scope.resetWatch();
              }

              scope.resetWatch = scope.$watch("dataSource", () => {
                if (scope.dataSource && scope.columnDefinitions) {
                  scope.options.api.deselectAll();

                  if (scope.mode === DisplayMode.GridView && !scope.fitWithinContainerWithId) {
                    scope.element.height(scope.getRowHeight() * scope.visibleRowCount + 30 + "px");
                  }

                  if (scope.fitWithinContainerWithId) {
                    scope.element.height((scope.element.parents(scope.fitWithinContainerWithId).height()) + "px");
                  }

                  if (!scope.softRefresh || !scope.options.columnApi.getAllColumns()) {
                    DataGrid.InitializeColumnDefinitions(scope);

                    let dataSourceReset = true;
                    const getRows = scope.dataSource.getRows;
                    scope.dataSource.getRows = (params: agGrid.IGetRowsParams & agGrid.IServerSideGetRowsParams) => {
                      if (!scope.autoRowHeight && scope.options.api) {
                        scope.options.api.showLoadingOverlay();
                      }

                      const successCallback = params.successCallback;

                      params.successCallback = (rowsThisBlock, lastRow) => {
                        if (scope.options.api) {
                          if (!scope.autoRowHeight) {
                            scope.options.api.hideOverlay();
                          }

                          scope.$emit("DataGridBlockLoadedEvent", {
                            name: scope.gridName,
                            startRow: params.startRow,
                            rows: rowsThisBlock,
                            totalRows: lastRow
                          });

                          successCallback(rowsThisBlock, lastRow);

                          if (params.startRow === 0) {
                            scope.$emit("DataGridFirstPageRenderedEvent", {
                              data: rowsThisBlock[0],
                              name: scope.gridName,
                              api: scope.options.api
                            });
                          }

                          if (scope.focusRowIndex !== null && scope.focusRowIndex !== undefined && scope.focusRowIndex >= 0 && dataSourceReset) {
                            if (!scope.autoRowHeight && scope.options.api.getInfiniteRowCount() < scope.focusRowIndex) {
                              scope.options.api.setInfiniteRowCount(scope.focusRowIndex, false);
                            }

                            scope.options.api.ensureIndexVisible(scope.focusRowIndex, "middle");

                            if (scope.autoRowHeight) {
                              if (scope.highlightFocusedRow) {
                                scope.options.api.setFocusedCell(scope.focusRowIndex, scope.options.columnApi.getAllColumns()[0]);
                              }
                            }
                          } else if (scope.scrollToBottom && dataSourceReset) {
                            scope.options.api.ensureIndexVisible(lastRow - 1, "middle");
                          }

                          if (scope.focusRowIndex === null || scope.focusRowIndex === undefined || scope.focusRowIndex <= params.endRow) {
                            dataSourceReset = false;
                          }
                        }
                      };

                      getRows(params);
                    };
                    scope.options.api.setColumnDefs(null);
                    scope.options.api.setColumnDefs(scope.columnDefinitions);
                    scope.options.api.setSortModel(scope.sortModel);
                    scope.options.api.setFilterModel(scope.filterModel);

                    if (scope.autoRowHeight || scope.rowGroupingMode) {
                      scope.options.api.setServerSideDatasource(scope.dataSource as agGrid.IServerSideDatasource);
                    } else {
                      scope.options.api.setDatasource(scope.dataSource as agGrid.IDatasource);
                    }
                  } else {
                    scope.options.api.refreshInfiniteCache();
                  }

                  if (!scope.autoRowHeight) {
                    scope.options.api.refreshCells({force: scope.softRefresh ? !scope.softRefresh : true});
                  }
                }
              });
            }
          };

          scope.getColumnHeaderName = colId => scope.options.columnApi.getAllColumns() ? scope.options.columnApi.getColumn(colId).getColDef().headerName : "";

          scope.sort = (colId, direction: SortDirection) => {
            const column: any = _.findWhere(scope.sortModel, {colId});
            column.sort = direction === SortDirection.ASC ? "asc" : "desc";

            scope.options.api.setSortModel(scope.sortModel);
          };

          scope.removeSort = colId => {
            const column: any = _.findWhere(scope.sortModel, {colId});
            scope.sortModel = _.without(scope.sortModel, column);

            scope.options.api.setSortModel(scope.sortModel);
          };

          scope.changeFilter = (colId, value) => {
            const column: any = _.findWhere(scope.filteredColumns, {colId});
            column.value = value;
            scope.filterModel = _.reduce(
              scope.filteredColumns,
              (acc, {colId, value}) => ({...acc, [colId]: value}),
              {}
            );
            scope.options.api.setFilterModel(scope.filterModel);
          };

          scope.removeFilter = colId => {
            const column: any = _.findWhere(scope.filteredColumns, {colId});
            scope.filteredColumns = _.without(scope.filteredColumns, column);

            scope.filterModel = _.reduce(
              scope.filteredColumns,
              (acc, {colId, value}) => ({...acc, [colId]: value}),
              {}
            );
            scope.options.api.setFilterModel(scope.filterModel);
          };

          scope.preventDefault = e => e.stopPropagation();

          scope._ = _;

          scope.$watch("currentPage", (page: number) => {
            scope.options.api.paginationGoToPage(page - 1);
          });

          scope.$watch("selectAll", (value: boolean) => {
            if(value !== undefined) {
              scope.options.api.forEachNode(n => n.setSelected(value));
            }
          });

          scope.$watchGroup(["pinnedTopRowData", "pinnedBottomRowData"], (data) => {
            scope.options.api.setPinnedTopRowData(data[0]);
            scope.options.api.setPinnedBottomRowData(data[1]);
          });
        },
        post: (scope: IDataGridScope, element: angular.IAugmentedJQuery) => {
          scope.element = element;
        }
      }
    };
  }

  public static GetSearchExpressionFromFilterModel(filter): SearchExpression {
    let keys = _.keys(filter);
    let values = _.values(filter);
    let root = values[0];
    let columnFilters = new SearchExpression();
    let map = (expression?: any) => {
      keys.forEach((column, index) => {
        let type = expression ? expression.type : values[index].type;
        let filter = expression ? expression.filter : values[index].filter;

        switch (type) {
          case "contains":
            columnFilters.fields.push(new MultiTextField(column, "", [new ListItem(filter, filter)], ComparisonType.Contains));
            break;
          case "notContains":
            columnFilters.fields.push(new MultiTextField(column, "", [new ListItem(filter, filter)], ComparisonType.NotContains));
            break;
          case "equals":
            columnFilters.fields.push(new MultiTextField(column, "", [new ListItem(filter, filter)], ComparisonType.Equals));
            break;
          case "notEquals":
            columnFilters.fields.push(new MultiTextField(column, "", [new ListItem(filter, filter)], ComparisonType.NotEquals));
            break;
          case "startsWith":
            columnFilters.fields.push(new MultiTextField(column, "", [new ListItem(filter, filter)], ComparisonType.StartsWith));
            break;
          case "endsWith":
            columnFilters.fields.push(new MultiTextField(column, "", [new ListItem(filter, filter)], ComparisonType.EndsWith));
            break;
        }
      });
    };

    if (root && root.operator) {
      columnFilters.operator = root.operator === "AND" ? Operator.And : Operator.Or;
      map(root.condition1);
      map(root.condition2);
    } else {
      map();
    }


    return columnFilters;
  }

  private static InitializeColumnDefinitions(scope: IDataGridScope) {
    if (scope.enableColumnPreferences && scope.mode !== DisplayMode.ListView) {
      scope.columnDefinitions.unshift({
        headerName: "",
        width: 120,
        pinned: "left",
        suppressSizeToFit: true,
        suppressNavigable: true,
        filter: false,
        suppressMovable: true,
        suppressMenu: true,
        sortable: false,
        lockPinned: true,
        lockPosition: true,
        lockVisible: true,
        resizable: false,
        headerClass: "preferences-column",
        cellRenderer: GridViewConfigCellRenderer,
        headerComponent: scope.rowCountHeaderComponent
      });
    }

    if (scope.mode === DisplayMode.ListView) {
      scope.columnDefinitions.forEach(c => c.hide = true);
      scope.columnDefinitions.unshift({
        headerName: "",
        suppressNavigable: true,
        filter: false,
        suppressMovable: true,
        suppressMenu: true,
        sortable: false,
        headerClass: "list-view-header-cell",
        cellClass: "list-view-cell",
        cellRenderer: scope.listViewCellRenderer
      });
    }

    if (scope.alternatingRows || (scope.alternatingRows === undefined && scope.mode === DisplayMode.GridView)) {
      scope.columnDefinitions.forEach(c => c.cellClass = c.cellClass ? `${c.cellClass}  alternating-rows` : "alternating-rows");
    }
  }
}

frontendApp.directive("iioDataGrid", ["$compile", Factory.Create(DataGrid)]);

// Expose as browser global so cross-module bare references resolve
(window as any).DataGrid = DataGrid;
